import React from 'react';
import { PainSection } from './PainSection';
import { ProductIntro } from './ProductIntro';
import { WorkbooksSection } from './WorkbooksSection';
import { BonusesSection } from './BonusesSection';
import { ValueStack } from './ValueStack';
import { AudienceSection } from './AudienceSection';
import { Testimonials } from './Testimonials';
import { HowItWorks } from './HowItWorks';
import { Guarantee } from './Guarantee';
import { ClosingBlock } from './ClosingBlock';
import { FAQ } from './FAQ';
import { Footer } from './Footer';
import { SocialProofPopup } from './SocialProofPopup';
import { FloatingCTA } from './FloatingCTA';
export function DeferredLanding() {
  return <>
      <PainSection data-id="element-56" data-mp="x051xotm2jto" />
      <ProductIntro data-id="element-57" data-mp="x1oi7ff9ouvg" />
      <WorkbooksSection data-id="element-58" data-mp="x16lyislugnj" />
      <BonusesSection data-id="element-59" data-mp="x2zn5ikg88o5" />
      <ValueStack data-id="element-60" data-mp="1bxe7bmfr1o4e" />
      <AudienceSection data-id="element-61" data-mp="1byz3fghppf4d" />
      <Testimonials data-id="element-62" data-mp="1byfmo33sswrx" />
      <HowItWorks data-id="element-63" data-mp="1bvjlm5wnlrz9" />
      <Guarantee data-id="element-64" data-mp="16z2x3aljlbln" />
      <ClosingBlock data-id="element-65" data-mp="16zm59zle4lmh" />
      <FAQ data-id="element-66" data-mp="17047rdynbw2u" />
      <Footer data-id="element-67" data-mp="170dyj3rim79l" />
      <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-68" data-mp="16wq8iela42zm" />
      <SocialProofPopup data-id="element-69" data-mp="1xy8gq649dtel" />
      <FloatingCTA data-id="element-70" data-mp="1xyrm6ncq2pbq" />
    </>;
}